import React from 'react';
import { Link } from 'react-router-dom';

export default class SecondaryButton extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log("SecondaryButton", this.props)
		return (
			<Link to={this.props.url}>
				<button
					type="button"
					className={
						'my-3 bg-black text-center hover:opacity-90 rounded-md' +
						(this.props.onShowcase ? ' md:w-40' : ' w-full md:w-68')
					}
					onClick={this.props.onClick}
				>
					<p className="text-lg py-2 px-8 text-white hover:underline">
						{this.props.label}
					</p>
				</button>
			</Link>
		);
	}
}
